import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { I360Service } from 'src/Services/i360Service';
import { MenuGroupModel } from 'src/Models/MenuGroupModel';
import { Router } from '@angular/router';
import { UserModel } from '../../../Models/usersModel';
import { FrontBriefingModel, FrontSolutionTracItModel } from 'src/Models/FrontSolutionTracItModel';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { RedirectService } from 'src/Services/RedirectService';
import { NewsModel } from 'src/Models/NewsModel';
import { FilterModel } from 'src/Models/filterModel';
import { HomePageBannerModel } from 'src/Models/HomePageBannerModel';
import { HomepagebannerService } from 'src/Services/homepagebanner.service';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';

@Component({
  selector: 'app-front-index',
  templateUrl: './front-index.component.html',
  styleUrls: ['./front-index.component.css']
})
export class FrontIndexComponent implements OnInit {
  menuModel = new MenuGroupModel();
  userModel = new UserModel();
  listOfBriefing!: FrontBriefingModel[];
  listOfFileCount!: FrontSolutionTracItModel[];
  userId: any;
  welcomeMessage: string = 'Welcome to JSi360';
  userHasTracIt: boolean = false;

  listOfNews!: NewsModel[];
  filterModel = new FilterModel();
  totalRecordCount: any;
  listOfBanner!: HomePageBannerModel[];
  listOfBannercount: number = 0;
  isLoading:boolean=false;
  isLoadingLibrary:boolean=false;

  constructor(private readonly redirectService: RedirectService,
    private readonly router: Router,
    private readonly titleService: Title,
    private readonly bannerService: HomepagebannerService,
    private readonly i360Service: I360Service,
    private readonly appActivity: ApplicationActivityService) {
    if (sessionStorage.getItem('userHasTracIt') == 'true')
      this.userHasTracIt = true;
    if (sessionStorage.getItem('UserId') != null && typeof (sessionStorage.getItem('UserId')) != 'undefined' && sessionStorage.getItem('UserId') != '0') {
      this.userId = sessionStorage.getItem('UserId');
    }
    else
      this.userId = sessionStorage.getItem('EncyUserId');

    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '9';
    this.filterModel.orderBy = 'PubDate DESC';
    this.filterModel.userID = this.userId;
    this.titleService.setTitle('Home | JSi360');
  }

  ngOnInit() {
    this.GetListOfFrontBriefing();
    setTimeout(() => {
    this.GetLibraryFileCount();  
    }, 1000);
    
    //this.i360NewsFindByPaged();
    setTimeout(() => {
      this.i360HomePageBanner();  
    }, 2000);
  }

  ngAfterViewInit(): void {

  }

  GetListOfFrontBriefing() {
    this.isLoading=true;
    this.listOfBriefing = [];
    this.i360Service.i360FrontBriefing().subscribe(
      data => {
        if (data['status'] == 'Success') {
          if (data['list'] != null) {
            this.listOfBriefing = data['list'];
          }
        }
        this.isLoading=false;
      },
      error => {
        this.isLoading=false;
        console.log(error);
      }
    );
  }

  GetLibraryFileCount() {
    this.isLoadingLibrary=true;
    this.i360Service.i360UserLibraryFileCount(this.userId).subscribe(
      data => {
        if (data['listOfFileCount'] != null) {
          this.listOfFileCount = data['listOfFileCount'];
        }
        this.isLoadingLibrary=false;
      },
      error => {
        this.isLoadingLibrary=false;
        console.log(error);
      }
    );
  }

  autoLoginInIRIS(url:any, briefingId:any) {
    this.applicationActivity('View', 'Home - Track-It', ActionActivity['Trac It'], url, briefingId);
    if (this.userHasTracIt) {
      this.i360Service.GenerateByPassAuthenticationKey().subscribe(
        data => {

          if (data != null) {
            if (data['status'] == 'Success') {
              let encyHasKey = data['encyHasKey'];
              if (data['encyHasKey'] != null) {
                let productName = ToolEnum[ToolEnum.actionitem].toString();
                let userName = sessionStorage.getItem('UserName');
                let param = { username: userName, password: encyHasKey, productname: productName.toLowerCase() };
                this.redirectService.post(param, url);
              }
            }
          }
        },
        error => {
          console.log(error);
        }
      );
    }
    else {
      if (sessionStorage.getItem('isLogin') == 'false') {
        let url = '/login';
        this.router.navigate([url]);
      }
      else {
        let productName = ToolEnum[ToolEnum.actionitem].toString();
        sessionStorage.setItem('productId', ToolEnum.briefingServices.toString());
        let url = '/Access/Denied/' + productName;
        this.router.navigate([url]);
      }

    }
  }
  navigateToProduct(url:any, productId:any, isLocked:any, productName:any) {
    if (isLocked) {
      let para = encodeURI(productName);
      url = '/Access/Denied/' + para;
    }
    this.applicationActivity('View', 'Home - ' + productName, productId);
    sessionStorage.removeItem('displayName');
    sessionStorage.setItem('productId', productId);
    sessionStorage.setItem('displayName', productName);
    this.router.navigate([url]);
  }

  i360NewsFindByPaged() {
    this.i360Service.i360Top9NewsFindByPaged(this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfNews = data['listOfNews'];
          if (this.listOfNews != null) {
            if (this.listOfNews.length > 0) {
              this.totalRecordCount = this.listOfNews[0].totalRecordCount;
            }
            else
              this.totalRecordCount = 0;
          }
          else
            this.totalRecordCount = 0;
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  i360HomePageBanner() {
    this.bannerService.i360HomePageBannerGetFront().subscribe(
      data => {
        if (data != null) {
          
          this.listOfBannercount = data['listOfBanner'].length;

          if (data['listOfBanner'].length > 0) {
            this.listOfBanner = data['listOfBanner'];
            setTimeout(() => {
              for (let index = 1; index < 500; index++) {
                const el = document.getElementById("ngb-slide-" + index);
                if (el) {
                  el.click();
                  break;
                }
              }

            }, 2000);
          }

        }
      },
      error => {
        console.log(error);
      }
    );
  }
  applicationActivity(actionName:any, pageName:any, datatype = 0, actionUrl = '', dataId = 0) {
    ApplicationActivityStore(actionName, pageName, this.appActivity, dataId, datatype, actionUrl)
  }

  rediretTonews() {
    this.router.navigate(['/News']);
    this.applicationActivity('View', 'Home - News', ActionActivity.News)
  }

  rediretToLibrary() {
    this.router.navigate(['/MyLibrary']);
    this.applicationActivity('View', 'Home - Library', ActionActivity['My Library'])
  }
}
